import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { consolidationByIdSelector, workspaceByIdSelector } from '@futrli/shared-services';
import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { StoreState } from '../../../skeleton/src/core/redux-utils/types';

/**
 * Returns the organisation or consolidation name (depending on what you are currently viewing)
 */
export const useOrganistionName = (workspaceIdArg?: string, organisationIdArg?: string) => {
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();

  const workspaceId = tempWorkspaceId || workspaceIdArg || '';
  const organisationId = tempOrganisationId || organisationIdArg || '';

  const organisationName: string | undefined = useSelector((store: StoreState) => {
    const { normalised } = store;
    const currentWorkspace = workspaceByIdSelector(normalised, workspaceId);
    const storedOrgs = currentWorkspace ? (currentWorkspace as WorkspacesListingItem).organisations : null;
    const org = storedOrgs?.find(o => o.id === organisationId);
    if (!org) {
      const consolidation = consolidationByIdSelector(normalised, organisationId);
      return consolidation?.name;
    }
    return org?.name;
  });

  return organisationName;
};
